var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7497 3.84961H2.24965C2.07287 3.84961 1.92822 3.99425 1.92822 4.17104V6.74247C1.92822 6.91925 2.07287 7.0639 2.24965 7.0639H33.7497C33.9264 7.0639 34.0711 6.91925 34.0711 6.74247V4.17104C34.0711 3.99425 33.9264 3.84961 33.7497 3.84961ZM33.7497 28.921H2.24965C2.07287 28.921 1.92822 29.0657 1.92822 29.2425V31.8139C1.92822 31.9907 2.07287 32.1353 2.24965 32.1353H33.7497C33.9264 32.1353 34.0711 31.9907 34.0711 31.8139V29.2425C34.0711 29.0657 33.9264 28.921 33.7497 28.921ZM33.7497 16.3853H2.24965C2.07287 16.3853 1.92822 16.53 1.92822 16.7068V19.2782C1.92822 19.455 2.07287 19.5996 2.24965 19.5996H33.7497C33.9264 19.5996 34.0711 19.455 34.0711 19.2782V16.7068C34.0711 16.53 33.9264 16.3853 33.7497 16.3853Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.3e6acd21.svg";
export { ForwardRef as ReactComponent };